import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { isMapOrNone } from '@aytm/app/stats/page/components/lib/utils'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'
import { calcChartTableProps } from '@aytm/app/stats/page/question-views/ec/lib/chart-table-utils'

// components
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'
import Controls from '@aytm/app/stats/page/question-views/sh/components/chart/Controls'
import Chart from '@aytm/app/stats/page/question-views/ec/components/chart/Chart'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'

// The chart half of an ecommerce question: the product-metrics view picker, the chart, and
// the per-product metrics table. Collapsing hides the chart and the table but keeps the
// controls visible so it can be reopened.
const ChartBlock = ({
  id,
  components,
  showPrice,
  isAmazon,
  hasBannerProducts,
  hasSubscribeProducts,
  chartCollapsed,
  isAnimated,
  percentDecimals,
  ignoreTraits,
  clickable,
  onModelChange,
  onChartCollapsedChange,
  onLabelClick,
  onSort,
  ...chartProps
}) => {
  const { viewMode, sortOrder, answer, answerVariants, priceTemplate, trait, traitName, isTraitType } = chartProps

  const tableProps = calcChartTableProps({
    id,
    answer,
    answerVariants,
    viewMode,
    sortOrder,
    percentDecimals,
    priceTemplate,
    trait,
    traitName,
    isTraitType,
    ignoreTraits,
    clickable,
    onLabelClick,
    onSort
  })

  return (
    <>
      {isComponentOn(components, 'controls') && (
        <Controls
          showPrice={showPrice}
          isAmazon={isAmazon}
          hasBannerProducts={hasBannerProducts}
          hasSubscribeProducts={hasSubscribeProducts}
          viewMode={viewMode}
          chartCollapsed={chartCollapsed}
          onModelChange={onModelChange}
          onToggle={onChartCollapsedChange}
        />
      )}
      {!chartCollapsed ? (
        <>
          {isComponentOn(components, 'chart') &&
            !isMapOrNone(chartProps.questionChartMode, chartProps.globalChartMode) && (
              <ChartPlaceholder isLoading={'loading' === answer} isAnimated={isAnimated}>
                <Chart questionId={id} {...chartProps} />
              </ChartPlaceholder>
            )}
          {isComponentOn(components, 'table') && <Table id={id} {...tableProps} />}
        </>
      ) : null}
    </>
  )
}

ChartBlock.displayName = 'EcommerceChartBlock'

ChartBlock.propTypes = {
  id: PropTypes.string,
  components: PropTypes.object,
  showPrice: PropTypes.bool,
  isAmazon: PropTypes.bool,
  hasBannerProducts: PropTypes.bool,
  hasSubscribeProducts: PropTypes.bool,
  chartCollapsed: PropTypes.bool,
  isAnimated: PropTypes.bool,
  percentDecimals: PropTypes.number,
  ignoreTraits: PropTypes.bool,
  clickable: PropTypes.bool,
  viewMode: PropTypes.string,
  sortOrder: PropTypes.string,
  answer: answerPropType,
  answerVariants: PropTypes.array,
  priceTemplate: PropTypes.string,
  trait: PropTypes.object,
  traitName: PropTypes.string,
  isTraitType: PropTypes.bool,
  onModelChange: PropTypes.func,
  onChartCollapsedChange: PropTypes.func,
  onLabelClick: PropTypes.func,
  onSort: PropTypes.func
}

export default ChartBlock
